import React from "react";
import { Typography, Select, MenuItem } from "@mui/material";

const EventTypeSelector = ({ eventTypes, value, onChange }) => (
  <>
    <Typography mt={2} fontWeight={600}>
      Event Type
    </Typography>
    <Select multiple fullWidth value={value} onChange={onChange}>
      {eventTypes.map((et) => (
        <MenuItem key={et.key} value={et.key}>
          {et.label}
        </MenuItem>
      ))}
    </Select>
  </>
);

export default EventTypeSelector;
